import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [
  ["/innov-manor.jpg", "Bron Menai Manor"],
  ["/innov-talk.jpg", "The FERAL Conversation"],
  ["/innov-kitchen.jpg", "Grace & James in the kitchen"],
  ["/innov-drinks.jpg", "Drinks from BAA BAA Bar"],
  ["/innov-sophie.jpg", "Pouring the evening"],
  ["/innov-bedroom.jpg", "Stay the night at Bron Menai"],
  ["/innov-sauna.jpg", "Sauna & spa after the evening"],
];

export const InnovatorsCarousel = () => {
  const ref = useRef(null);
  const [i, setI] = useState(0);

  const go = (n) => {
    const el = ref.current;
    const idx = (n + SLIDES.length) % SLIDES.length;
    el.scrollTo({ left: el.children[idx].offsetLeft - el.offsetLeft, behavior: "smooth" });
    setI(idx);
  };

  useEffect(() => {
    const t = setInterval(() => go(i + 1), 5000);
    return () => clearInterval(t);
  });

  const onScroll = () => {
    const el = ref.current;
    const w = el.children[0]?.offsetWidth || 1;
    setI(Math.round(el.scrollLeft / w));
  };

  return (
    <section className="py-16" data-testid="innovators-carousel">
      <div className="max-w-6xl mx-auto px-6 relative">
        <div ref={ref} onScroll={onScroll} className="flex overflow-x-auto snap-x snap-mandatory rounded-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {SLIDES.map(([src, cap]) => (
            <figure key={src} className="relative shrink-0 w-full snap-start h-[58vh] min-h-[320px] max-h-[620px]">
              <img src={src} alt={cap} className="w-full h-full object-cover" loading="lazy" />
              <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent px-6 pt-12 pb-5 text-[#f0dbbe] text-sm tracking-[0.12em] uppercase">{cap}</figcaption>
            </figure>
          ))}
        </div>
        <button onClick={() => go(i - 1)} aria-label="Previous photo" data-testid="carousel-prev" className="absolute left-9 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/45 hover:bg-black/70 text-[#f2e5de] flex items-center justify-center transition-colors"><ChevronLeft size={20} /></button>
        <button onClick={() => go(i + 1)} aria-label="Next photo" data-testid="carousel-next" className="absolute right-9 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/45 hover:bg-black/70 text-[#f2e5de] flex items-center justify-center transition-colors"><ChevronRight size={20} /></button>
        <div className="flex justify-center gap-2 mt-4">
          {SLIDES.map(([src], n) => (
            <button key={src} onClick={() => go(n)} aria-label={`Photo ${n + 1}`} className={`h-1.5 rounded-full transition-[width,background-color] ${n === i ? "w-6 bg-[#ebc754]" : "w-1.5 bg-[#4a3b31]"}`} />
          ))}
        </div>
      </div>
    </section>
  );
};
